export enum DocumentFormatEnum {
    Any = 1,
    Image = 2
}
